module.exports = __webpack_public_path__ + "img/guide.8cc081d8.jpg";